import React, { useState, useEffect, useContext } from "react";
import { Link } from "react-router-dom";
import {
  Container,
  Navbar,
  ListGroup,
  Row,
  Col,
  Button,
} from "react-bootstrap";
import { isMobile } from "react-device-detect";
import _ from "lodash";
// import queryString from 'query-string';
import ApiHome from "../../core/api/api.home";
import { Bounce } from "react-awesome-reveal";
import pic404 from "../../assets/images/404.svg";
// import {
//   AlertTriangle
// } from 'feather-icons-react';
function PageNotFound() {
  //const url = queryString.parse(window.location.href);

  useEffect(() => {
    (async () => {
      try {
        // دریافت request 404
        const basket = await ApiHome.pageNotFound({ url: "" });
      } catch (error) {}
    })();
    return () => {};
  }, []);

  return (
    <Bounce>
      <Container fluid className="main-content">
        <Container>
          <Row className=" text-small mx-0">
            <Col xs="12" md="4" className=" pt-4 px-0 text-center">
              <img src={pic404} alt="خطا" className="w-100" />
            </Col>
            <Col className="text-center my-auto">
              <h2 className="fw-bold fs-103">نتیجه ای یافت نشد !</h2>
              <p className="text-center ">
                صفحه مورد نظر شما منتقل شده،حذف شده تغییر نام داده یا هرگز وجود
                نداشته است
              </p>
              <Link to="/" className=" btn btn-primary py-2 px-5 rounded-3">
                بازگشت به صفحه اصلی
              </Link>
            </Col>
          </Row>
        </Container>
      </Container>
    </Bounce>
  );
}
export default PageNotFound;
